import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { filter, map, mergeMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Favicons } from './core/favicons/favicons';
import { IAppState } from './core/store/interfaces/IAppState';
import { selectEnterprise, selectIsLogged } from './core/store/selectors';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  hideHeader = false;

  isLogged!: boolean;
  private favicons: Favicons;
  enterprise$ = this.store.select(selectEnterprise);


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store<IAppState>,
    private cd: ChangeDetectorRef,
    favicons: Favicons
  ) {
    this.favicons = favicons;

    this.router.events
      .pipe(
        filter(e => e instanceof NavigationEnd),
        map(() => {
          let r = this.route;
          while (r.firstChild) r = r.firstChild;
          return r;
        }),
        mergeMap(r => r.data)
      );

    // Detectar mudanças de rota com type casting correto
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd)
    ).subscribe((event) => {
      const isAnalystView = event.url.includes('/chamados/analyst-view');
      const isExternal = localStorage.getItem('isExternalAccess') === 'true';

      // Ocultar header se for analyst-view ou modo externo
      this.hideHeader = isAnalystView || isExternal;

      // Limpar modo externo ao navegar para rotas normais
      if (!isAnalystView && isExternal) {
        console.log('🧹 Limpando modo externo - navegação para rota normal');
        localStorage.removeItem('isExternalAccess');
        localStorage.removeItem('externalAuthKey');
        localStorage.removeItem('externalCallCode');
        localStorage.removeItem('externalIdClient');
        localStorage.removeItem('externalToken');
      }
    });
  }

  ngOnInit(): void {
    // Verificar no init também
    const isAnalystView = this.router.url.includes('/chamados/analyst-view');
    const isExternal = localStorage.getItem('isExternalAccess') === 'true';
    this.hideHeader = isAnalystView || isExternal;

    this.enterprise$.subscribe((res) => {
      this.useFavicon(res?.logoTransparenteUrl as string);
    });

    this.store.select(selectIsLogged).subscribe((v) => {
      this.isLogged = v;
      this.cd.detectChanges();
    });
  }

  public useFavicon(href: string): void {
    this.favicons.activate(href);
  }
}
